import React, { createContext, useContext, useState } from "react";

// Create the context
const LanguageContext = createContext();

// Custom hook to use the context
export const useLanguage = () => useContext(LanguageContext);

// Language provider component
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState("en"); // Default is English

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
